import { MobileGamepadInputStandalone, MobileGamepadUi } from '@playcastdotio/MobileGamepad';
import { useInputCaptureManager } from './useInputCaptureManager';

export const MobileGamepadPage = () => {
  useInputCaptureManager({
    access: { mouse: true, keyboard: true, touch: false, gamepad: true },
    active: true,
  });

  return (
    <div className='relative flex h-screen min-h-screen flex-col overflow-hidden bg-black'>
      <MobileGamepadInputStandalone enabled={true} />
      <MobileGamepadUi testMode={true} />
    </div>
  );
};
